import ChatPreview from '@/components/ChatPreview'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

export default function BumiLandingPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const messages = [
    { from: 'companion' as const, text: t('pages.landing.chatMessage1') },
    { from: 'user' as const, text: t('pages.landing.chatMessage2') },
    { from: 'companion' as const, text: t('pages.landing.chatMessage3') },
  ]

  return (
    <>
      <header className="mx-auto w-full max-w-5xl px-6 py-4">
        <div className="flex items-center justify-between">
          <span className="text-primary font-serif text-[1.75rem] leading-none">
            bumi
          </span>
          <Link
            to="/account/sign-in"
            className="text-primary text-[0.85rem] font-semibold no-underline"
          >
            {t('buttons.login', { defaultValue: 'Log In' })}
          </Link>
        </div>
      </header>

      <main className="flex grow flex-col items-center justify-center px-6 pt-14 pb-20 text-center">
        <div className="mb-8 flex w-full justify-center">
          <ChatPreview messages={messages} />
        </div>

        <h1 className="text-primary max-w-md font-serif text-[2.2rem] leading-tight font-normal md:text-[2.8rem]">
          {t('pages.landing.heading')}
        </h1>

        <p className="text-muted mt-4 max-w-sm text-[1.05rem] leading-relaxed">
          {t('pages.landing.subheading')}
        </p>

        <button
          onClick={() => navigate('/onboarding')}
          className="bg-primary mt-8 w-full max-w-[340px] rounded-[14px] px-7 py-[18px] text-[1.05rem] font-semibold text-white transition hover:-translate-y-0.5 hover:shadow-lg"
        >
          {t('pages.landing.startNow')}
        </button>
      </main>

      <footer className="flex items-center justify-center px-6 py-6">
        <div className="flex flex-wrap justify-center space-x-2 text-[0.8rem] text-[#BBBFCB]">
          <Link
            to="https://app-studio.ai/terms"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.terms', { defaultValue: 'Terms and Conditions' })}
          </Link>
          <span>&middot;</span>
          <Link
            to="https://app-studio.ai/privacy"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.privacy', { defaultValue: 'Privacy Policy' })}
          </Link>
          <span>&middot;</span>
          <Link
            to="/help-center"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.help', { defaultValue: 'Help Center' })}
          </Link>
          <span>&middot;</span>
          <Link
            to="/help-center/contact"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.contact', { defaultValue: 'Contact' })}
          </Link>
          <span>&middot;</span>
          <Link
            to="/help-center/cancel-subscription"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.cancelSubscription', {
              defaultValue: 'How to Cancel Subscription',
            })}
          </Link>
        </div>
      </footer>
    </>
  )
}
